import { openModal } from '@core/components/ModalStack';
import { OrderOverlayProps } from './OrderOverlay';

export async function openOrderOverlay(props: OrderOverlayProps) {
  const { OrderOverlay } = await import('./OrderOverlay');

  openModal(OrderOverlay, props);
}
